import { render, staticRenderFns } from "./SvgBackgroundShop.vue?vue&type=template&id=49989adf&scoped=true"
import script from "./SvgBackgroundShop.vue?vue&type=script&lang=ts"
export * from "./SvgBackgroundShop.vue?vue&type=script&lang=ts"
import style0 from "./SvgBackgroundShop.vue?vue&type=style&index=0&id=49989adf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49989adf",
  null
  
)

export default component.exports